import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box'
import { Typography, Grid, Card, CardContent, Chip, Divider } from '@mui/material';
import MDButton from 'components/MDButton';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Check, Close, KeyboardReturnRounded, LocalShippingRounded, MoreVertOutlined } from '@mui/icons-material';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useApi } from "lib/api";

function Listtransf(props) {
  const { post } = useApi();

   const [currentItem,setCurrentItem] = useState()
   const [currentsucursal,setCurrentSucursal] = useState('')
   const [rows,setRows] = useState([])
   const [transferidos,setTransferidos] = useState([])
   const sucursales = props.sucursales;

   const [expanded, setExpanded] = useState(0);
   const [filtered, setfiltered] = useState([])
   const [completos, setCompletos] = useState([])
   const [progreso, setProgreso] = useState([])

  // Sin "Ver sucursal" la lista trae solo la sucursal propia: se elige sola.
  useEffect(() => {
    if (sucursales && sucursales.length === 1 && !currentsucursal) {
      setCurrentSucursal(sucursales[0].label || '')
    }
  }, [sucursales, currentsucursal])
   
   

  async function buscarmotores(){

    const { status, data } = await post('/api/listtransf', {'tipo':props.tipo,'sucursal': currentsucursal})
    if (status === 200) {
      //rows = [data["facturacion"]]
        setRows(data["motorgroup"])
        setTransferidos(data["transacciones"])
       setCurrentItem(undefined)

      var dato = ''
      data["motorgroup"].map((e)=>{
        if(e.sreceptor==null){
          dato = e
        }
      })
      console.log(dato)

    } else if (status === 400) {
      setRows([])
      alert(data["Error"])

    }
  }
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  
  function filteredTranf(idtransaccion){
    var item = transferidos.filter(value => value['idtransaccion']===idtransaccion);    
    return item;
  };

  function iscompleted(idtransaccion){
    var completed = filteredTranf(idtransaccion).filter(value=> value['status']==="Devuelta" || value['status']==="Completado")
    var iscompleted = false;
    if(filteredTranf(idtransaccion).length == completed.length){
      iscompleted = true;
    }

    return iscompleted;
  };

  function devoluciones(idtransaccion){
    var devueltas = filteredTranf(idtransaccion).filter(value=> value['status']==="Devuelta")
    
    return devueltas;
  };


    return (
      <Grid container spacing={3}>
        <Grid item xs={12} lg={8}>
            <Grid container>
                <Grid item xs={12}>
                  <Card elevation={2} sx={{ borderRadius: 2, mb: 3 }}>
                    <CardContent>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 700 }}>Seguimiento de transferencias</Typography>
                    <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={6}>
                    <Autocomplete
                        variant = "outlined"
                        disablePortal
                        id="combo-box-demo"
                        options={sucursales}
                        value={currentsucursal || null}
                        onChange={(event, value) => setCurrentSucursal(value?.label || value || "")}
                        getOptionLabel={(opt) => (typeof opt === "string" ? opt : (opt?.label || ""))}
                                      
                        renderInput={(params) => 
                          <TextField {...params} 
                            variant="outlined"
                            label="Seleccionar sucursal" 
                            fullWidth
                            InputLabelProps={{
                                shrink: true,
                            }}
                            sx={{ '& .MuiOutlinedInput-root': { height: '45px', minHeight: '45px' } }}
                            />}
                    />
                    </Grid>
                    <Grid item xs={12} md={3}>
                  <MDButton variant="gradient" color="success" onClick={()=>buscarmotores()}  fullWidth>Buscar</MDButton>
                    </Grid>
                    </Grid>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sx={{backgroundColor:'white',borderRadius:2,boxShadow:3,minHeight:200}}>
                    {rows.map((value,i)=>(
                        <Accordion expanded={expanded === i} onChange={handleChange(i)}>
                          
                            <AccordionSummary
                                onClick={()=>{setCurrentItem(value)}}
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1-content"
                                id="panel1-header"
                                style={{fontWeight:"bold"}}>{`${value["stransmisor"].split("-")[1]}-${value["sreceptor"].split("-")[1]} ${value['fechatransm']}`} 
                                
                                {iscompleted(value["idtransaccion"]) ? (
                                  <Chip label="Completado" color="success" size="small" sx={{ ml: 1, fontWeight: 600 }} />
                                ) : (
                                  <Chip label="En progreso" color="primary" size="small" sx={{ ml: 1, fontWeight: 600 }} />
                                )}
                                


                                {value['devoluciones']!=undefined && value['devoluciones'].includes("Devolucion") ? (
                                  <Chip label="Devolucion" color="error" size="small" sx={{ ml: 1, fontWeight: 600 }} />
                                ) : ''}
                                
                              </AccordionSummary>
                                

                                {
                                <List sx={{bgcolor: 'background.paper', maxHeight:240,position:'relative',overflow: 'auto',marginLeft:4,marginRight:4}}> 
                                  {filteredTranf(value['idtransaccion']).map((valueM) => (
                                  <ListItem>
                                    <ListItemText
                                    primary={valueM.chasis}
                                    secondary={`Marca:${valueM.marca}, Color:${valueM.colore}`}/>
                                      {valueM.status=="Completado"?
                                      <Check style={{fontWeight:"bold",color:"green",marginRight:10}}></Check>
                                       :''}
                                       {valueM.status=="Devuelta"?
                                       <LocalShippingRounded style={{fontWeight:"bold",color:"red",marginRight:10}}></LocalShippingRounded>
                                       :''}
                                       {valueM.status=="En progreso"?
                                        <Close style={{fontWeight:"bold",color:"red",marginRight:10}}></Close>
                                       :''}
                                   </ListItem>
                                   ))}
                                </List>
                                }
                        </Accordion>


                    ))}


                </Grid>
            </Grid>

        </Grid>
        <Grid item xs={12} lg={4}>
          {currentItem!=undefined?
          <Card elevation={2} sx={{ borderRadius: 2 }}>
            <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="h6" sx={{ fontWeight: 700 }}>Detalles</Typography>
                <Divider sx={{ my: 1.5 }} />
              </Grid>          
              <Grid item xs={6}  marginTop={1}>
                <p style={{fontWeight:"bold",fontSize:14}}>status:</p>
              </Grid>  
              <Grid item xs={6}  marginTop={1}>
                {iscompleted(currentItem["idtransaccion"])?
                  <p style={{fontWeight:"bold",fontSize:14,color:'green'}}>Completado</p>
                : <p style={{fontWeight:"bold",fontSize:14,color:'blue'}}>En progreso</p>}
                
              </Grid>

              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Transportador:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{currentItem.transportista}</p>
              </Grid>  

              <Grid item lg={6} >
                <p style={{fontWeight:"bold",fontSize:14}}>Proviene de:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{currentItem.stransmisor.split("-")[1]}</p>              
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Enviado por:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{currentItem.transmuser}</p>
              </Grid>
              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Fecha de salida:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{currentItem.fechatransm}</p>
              </Grid>
              <Grid item lg={6} >
                <p style={{fontWeight:"bold",fontSize:14}}>Recibido en:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{currentItem.sreceptor.split("-")[1]}</p>              
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Recibido por:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{currentItem.receptoruser}</p>
              </Grid>
              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Fecha de llegada:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{currentItem.fecharecep}</p>
              </Grid>
              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Cantidad:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{filteredTranf(currentItem["idtransaccion"]).length}</p>
              </Grid>
              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Devoluciones:</p>
              </Grid>  
              <Grid item lg={6}>
                <p style={{fontSize:14}}>{devoluciones(currentItem["idtransaccion"]).length}</p>
              </Grid>

              <Grid item lg={6}>
                <p style={{fontWeight:"bold",fontSize:14}}>Comentario de salida:</p>              
              </Grid>  
              <Grid item xs={6}>
                <p style={{fontSize:14}}>{currentItem.comentransm}</p>              
              </Grid>  

            </Grid>
            </CardContent>
          </Card>

          :''}


        </Grid>

     </Grid>   
    );    
}
export default Listtransf;
